import { tryParseJson } from '@jbhi-fi/utils/src/JSON/tryParseJson';
import { getLocal, setLocal, LocalStorageKeys } from '@jbhi-fi/utils/src/localStorage';

/**
 * Get the stored recently viewed skus
 * @returns Array of SKU numbers excluding the current sku
 */
export const getStoredRecentlyViewedSkus = (): Array<number> => {
  try {
    const storedProductSkus =
      tryParseJson<Array<string | number | null>>(getLocal(LocalStorageKeys.RecentlyViewed)) ?? [];
    if (!storedProductSkus.length) {
      return [];
    }

    const transformedStoredProductSkus = storedProductSkus
      .map((sku: number | string | null | undefined) => (sku ? Number(sku) : null))
      .filter((sku: number | null) => sku && !isNaN(sku)) as Array<number>;

    const currentSku = Number(window.Jbhifi.sku);
    if (!currentSku || !transformedStoredProductSkus.includes(currentSku)) {
      return transformedStoredProductSkus;
    }

    return transformedStoredProductSkus.filter((sku: number) => sku !== currentSku);
  } catch (error) {
    console.warn(error);
    return [];
  }
};

/**
 * Set the stored recently viewed skus
 * @description Adds the current SKU to the start of stored SKUs array
 */
export const setStoredRecentlyViewedSku = (): void => {
  try {
    const currentSku = Number(window.Jbhifi.sku);
    if (!currentSku) return;

    // Stored products won't contain the SKU we'll add to start of array
    const storedProducts = [currentSku, ...getStoredRecentlyViewedSkus()];
    if (storedProducts.length > 12) {
      storedProducts.pop();
    }

    setLocal(LocalStorageKeys.RecentlyViewed, JSON.stringify(storedProducts));
  } catch (error) {
    console.warn(error);
  }
};
